export enum CountryCode {
  Netherlands = '+31',
  Belgium = '+32',
  France = '+33',
  Italy = '+39',
  Switzerland = '+41',
  Austria = '+43',
  Germany = '+49',
}
